<template>
  <v-dialog v-model="isOpen" persistent max-width="920">
    <v-card class="align-center text-center">
      <div class="pt-5 d-flex align-center justify-space-between px-3">
        <div class="d-flex pl-2">
          <h1>Detalhes da Entrega</h1>
        </div>
        <v-btn icon @click="$emit('update:isOpen'), $emit('cancelClick')" class="align-self-end">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </div>
      <v-card-text class="d-flex align-center text-left px-2">
        <div class="ctes-container">
          <DeliveryHierarchy ref="DeliveryHierarchy" :delivery="item" :details="true" />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DeliveryHierarchy from '@/components/ManualBoardingImport/Stepper/Step2/DeliveryHierarchy.vue';

export default {
  components: {
    DeliveryHierarchy
  },
  props: {
    isOpen: {
      default: true,
      type: Boolean
    },
    item: {
      default: () => ({}),
      type: Object
    },
    confirmButtonText: {
      default: 'Confirmar',
      type: String
    },
    confirmText: {
      default: 'Confirmar',
      type: String
    },
    bodyText: {
      default: 'entregas',
      type: String
    },
    isConfirmBtnLoading: {
      default: false,
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
.ctes-container {
  width: 100%;
  height: auto;
  max-height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
